import { Modal } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import { CheckCircle2 } from 'lucide-react';
import useDeferConfirmStore from '@/stores/useDeferConfirmStore';

// Singleton success popup shown after a "Defer to next day" response
// resolves, from EITHER the RolloverToast or the in-row PickupSlotCell
// buttons (both open it via useDeferConfirmStore). Purely informational —
// unlike the mandatory slot modal, mask-click/ESC ARE allowed to close it.
const DeferConfirmModal = () => {
  const { t } = useTranslation();
  const { data, closeDeferConfirm } = useDeferConfirmStore();

  return (
    <Modal
      open={!!data}
      centered
      width={384}
      footer={null}
      closable={false}
      maskClosable
      keyboard
      onCancel={closeDeferConfirm}
      transitionName=''
      maskTransitionName=''
    >
      {data ? (
        <div className='py-2 text-center'>
          <span
            className='mx-auto flex h-14 w-14 items-center justify-center rounded-full'
            style={{ background: 'rgba(49,196,127,0.12)' }}
          >
            <CheckCircle2 size={30} color='rgb(39,155,101)' />
          </span>
          <h2 className='mt-4 text-lg font-bold'>{String(t('slot_defer_confirm_title'))}</h2>
          <p className='mt-1.5 text-sm text-[rgb(115,123,140)]'>
            <Trans
              i18nKey='slot_defer_confirm_body'
              values={{ label: data.label, window: data.window }}
              components={{ strong: <strong className='text-[rgb(57,57,60)]' /> }}
            />
          </p>
          <button
            type='button'
            onClick={closeDeferConfirm}
            // v2-task-8b (§3.7): rounded-lg (8px) for parity with
            // SlotModal's footer CTA — both are "the one primary action
            // button in a modal footer." Height stays h-10 (this is a
            // single, isolated full-width CTA, not competing with a
            // side-by-side Cancel button).
            className='mt-5 h-10 w-full rounded-lg bg-[rgb(237,224,74)] text-sm font-semibold text-[rgb(57,57,60)] transition-colors hover:bg-[rgb(230,217,60)] active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[rgb(237,224,74)]'
          >
            {String(t('got_it'))}
          </button>
        </div>
      ) : null}
    </Modal>
  );
};

export default DeferConfirmModal;
